import Vue from "vue";

import "@/plugins/config.js";
import "@/services";
import { ENDPOINTS } from "@/services/Endpoints.js";

// CONFIGURAÇÃO DE COSTUMIZAÇÃO

Vue.prototype.$financeiro_formas_pgto = new Vue({
  data() {
    return {
      ENDPOINTS: ENDPOINTS,
      formas_pgto_AddEdit: "new",
      add_formas: false,
      formas_pgto_loading: false,
      formas_pgto_button_loading: false,
      filter_loading: false,
      canal_venda: [
        { text: "Loja", value: "LOJA" },
        { text: "Marketplace", value: "MARKETPLACE" },
      ],
      cadastro: {
        idforma_pag: "",
        ordem: "",
        descricao: "",
        status: "",
        juros: "",
        parcelas: "",
        tipo: "",
        error: {
          ordem: [],
          descricao: [],
          status: [],
          tipo: [],
        },
      },
      formas_pagamento: [],
      filtros: [],
      filter: {
        loja: "",
        canal_venda: this.isAdmin() ? "MARKETPLACE" : "LOJA",
        idforma_pag: "",
        descricao: "",
        status: "",
        error: {
          loja: [],
        },
      },
      status: [
        { text: "ATIVO", value: "ATIVO" },
        { text: "INATIVO", value: "INATIVO" },
      ],
      modosPgto: [],
      text: "",
      funcao: "",
    };
  },

  methods: {
    /**
     * @description Método para listar formas de pagamento
     * @returns {Promise} Retorna uma promise com o resultado da requisição
     */
    getFormasPgto() {
      this.formas_pgto_loading = true;
      this.$axios
        .post(this.ENDPOINTS.LISTAR_FORMAS_DE_PAGAMENTO)
        .then(response => {
          if (response) {
            this.formas_pgto_button_loading = false;
            this.formas_pagamento = response;
            this.formas_pgto_loading = false;
          }
        })
        .catch(error => {
          throw new Error(error);
        });
    },

    isAdmin() {
      if (
        this.$axios.getLocal("oe_user_info", true).data?.user_type === "admin"
      )
        return true;
      return false;
    },

    /**
     * @description Método para listar os Modos de pagamento
     * @returns {Promise} Retorna uma promise com o resultado da requisição
     */
    getModosPgto() {
      this.$axios
        .get(this.ENDPOINTS.FORMAS_DE_PAGAMENTO + "array")
        .then(response => {
          if (response) {
            this.modosPgto = response;
          }
        })
        .catch(error => {
          throw new Error(error);
        });
    },

    /**
     * @description Método para deletar uma forma de pagamento
     * @param {String} idforma_pag - ID da forma de pagamento
     * @returns {Promise} Retorna uma promise com o resultado da requisição e chama o método de listagem para atualizar a lista
     */
    deletarFormaPgto(idforma_pag) {
      this.$axios
        .delete(this.ENDPOINTS.DELETAR_FORMAS_DE_PAGAMENTO + idforma_pag)
        .then(() => this.getFormasPgto())
        .catch(error => {
          throw new Error(error);
        });
    },

    /**
     * @description Método para alterar uma forma de pagamento
     * @param {Object} dados - Dados da forma de pagamento
     * @returns {Promise} Retorna uma promise com o resultado da requisição, fecha o modal e chama o método de listagem para atualizar a lista
     */
    alterarFormaPgto() {
      this.formas_pgto_button_loading = true;
      let dados = {
        ordem: this.cadastro.ordem,
        descricao: this.cadastro.descricao,
        status: this.cadastro.status,
        juros: this.cadastro.juros,
        num_parcelas: this.cadastro.parcelas,
        tipo: this.cadastro.tipo,
      };

      this.$axios
        .put(
          this.ENDPOINTS.ALTERAR_FORMAS_DE_PAGAMENTO +
            this.cadastro.idforma_pag,
          dados
        )
        .then(() => {
          this.formas_pgto_button_loading = false;
          this.limparFormularioFormasPgto();
        })
        .catch(error => {
          this.formas_pgto_button_loading = false;
          throw new Error(error);
        })
        .finally(() => {
          this.add_formas = false;
          this.getFormasPgto();
        });
    },

    /**
     * @description Método para cadastrar uma nova forma de pagamento
     * @param {Object} dados - Dados da forma de pagamento
     * @returns {Promise} Retorna uma promise com o resultado da requisição, fecha o modal e chama o método de listagem para atualizar a lista
     */
    async cadastrarFormaPgto() {
      this.formas_pgto_button_loading = true;
      let dados = {
        ordem: this.cadastro.ordem,
        descricao: this.cadastro.descricao,
        status: this.cadastro.status,
        num_parcelas: this.cadastro.parcelas,
        juros: this.cadastro.juros,
        tipo: this.cadastro.tipo,
      };

      await this.$axios
        .post(this.ENDPOINTS.CADASTRAR_FORMAS_DE_PAGAMENTO, dados)
        .then(() => {
          this.formas_pgto_button_loading = false;
          this.limparFormularioFormasPgto();
        })
        .catch(() => {
          this.formas_pgto_button_loading = false;
        })
        .finally(() => {
          this.add_formas = false;
          this.getFormasPgto();
        });
    },

    /**
     * @description Método para abrir o modal de confirmação de remoção de formas de pagamento
     * @param {id} String - ID da forma de pagamento
     * @param {msg} String - Mensagem de confirmação
     */
    remover(id, msg) {
      this.$config.modalConfirm = true;
      this.text = msg;
      this.cadastro.idforma_pag = id;
    },

    /**
     * @description Método de confirmação de remoção de forma de pagamento
     */
    funcaoRemover() {
      this.deletarFormaPgto(this.cadastro.idforma_pag);
    },

    /**
     * @description Método para filtrar formas de pagamento
     * @param {Array} filtros - Filtros a serem aplicados
     * @returns {Promise} Retorna uma promise com o resultado da requisição
     */
    filtroFormasPgto() {
      if (this.filter.loja !== 0) {
        if (
          (this.filter.loja === "" || this.filter.loja === null) &&
          this.filter.canal_venda === "LOJA"
        ) {
          this.$config.alert(
            "Selecione uma loja!",
            this.$config.dados.errorColor
          );
          this.filter.error.loja = "Selecione uma loja!";
          return;
        }
      }
      this.formas_pgto_loading = true;
      this.filter_loading = true;
      this.filtros = [];
      if (this.filter.idforma_pag != "") {
        this.filtros.push({
          campo: "idforma_pag",
          tipo: "string",
          orientacao: "like",
          valor: this.filter.idforma_pag,
        });
      }

      if (this.filter.descricao != "") {
        this.filtros.push({
          campo: "descricao",
          tipo: "string",
          orientacao: "like",
          valor: this.filter.descricao,
        });
      }

      if (this.filter.status != "" || this.filter.status != null) {
        this.filtros.push({
          campo: "status",
          tipo: "string",
          valor: this.filter.status,
        });
      }

      let loja;
      if (this.filter.loja != "" && this.filter.canal_venda === "LOJA")
        loja = this.filter.loja;
      else loja = null;

      let filtered = this.filtros;
      this.$axios
        .post(
          this.ENDPOINTS.LISTAR_FORMAS_DE_PAGAMENTO,
          JSON.stringify({ loja, filtros: filtered })
        )
        .then(response => {
          this.formas_pagamento = response;
          this.filter_loading = false;
          this.formas_pgto_loading = false;
        })
        .catch(error => {
          this.filter_loading = false;
          this.formas_pgto_loading = false;
          throw new Error(error);
        });
    },

    // ---- // ---------------------------------------- FUNÇÕES AUXILIARES ---------------------------------------- // ---- //

    /**
     * @description Método para validar os campos do formulário de cadastro/alteração de uma forma de pagamento
     * @param {String} descricao - Descrição da forma de pagamento
     * @param {String} status - Status da forma de pagamento
     * @param {String} formas_pgto_AddEdit - Tipo de cadastro (new ou edit)
     * @returns {Function} Retorna uma função alterarFormaPgto ou cadastrarFormaPgto
     */
    async validarCadastro() {
      // VALIDAÇÃO DOS DADOS CADASTRAIS
      if (this.cadastro.ordem == "") {
        this.$config.alert(
          "Preencha a ordem corretamente!",
          this.$config.dados.errorColor
        );
        this.cadastro.error.ordem = "Preencha a ordem corretamente!";
        return;
      }

      if (this.cadastro.descricao == "") {
        this.$config.alert(
          "Preencha a descrição corretamente!",
          this.$config.dados.errorColor
        );
        this.cadastro.error.descricao = "Preencha a descrição corretamente!";
        return;
      }

      if (this.cadastro.status == "") {
        this.$config.alert(
          "Selecione o status da forma de pagamento!",
          this.$config.dados.errorColor
        );
        this.cadastro.error.status =
          "Selecione o status da forma de pagamento!";
        return;
      }

      if (this.cadastro.tipo == "") {
        this.$config.alert(
          "Selecione o tipo da forma de pagamento!",
          this.$config.dados.errorColor
        );
        this.cadastro.error.tipo = "Selecione o tipo da forma de pagamento!";
        return;
      }

      if (this.formas_pgto_AddEdit == "edit") {
        this.alterarFormaPgto();
        return;
      }

      this.cadastrarFormaPgto();
    },

    limparFormularioFormasPgto() {
      this.cadastro.idforma_pag = "";
      this.cadastro.ordem = "";
      this.cadastro.descricao = "";
      this.cadastro.status = "";
      this.cadastro.juros = "";
      this.cadastro.parcelas = "";
      this.cadastro.tipo = "";
      this.cadastro.error.descricao = [];
      this.cadastro.error.ordem = [];
      this.cadastro.error.status = [];
      this.cadastro.error.tipo = [];
    },

    limparFiltros() {
      this.filter.idforma_pag = "";
      this.filter.descricao = "";
      this.filter.status = "";
      this.filter.loja = "";
      this.filter.error.loja = [];
    },
  },
});
